module.exports = __webpack_public_path__ + "img/Weapon_259.9d3fe87b.png";